import { ArrayTable } from './ArrayTable';
import { Card } from './Card';
export var ArrayCards = Card;
ArrayCards.Addition = ArrayTable.Addition;
